import React from 'react';
import { BackgroundColor } from '@/components/interfaces/graphql/HtmlElement/HtmlElementUtils';

interface ButtonSnippetProps {
  ariaLabel?: string;
  autoHide?: boolean;
  backgroundColor?: BackgroundColor;
  buttonMaxWidth?: string;
  buttonTextEn?: string;
  buttonTextEs?: string;
  className?: string;
  displayAsLink?: boolean;
  destinationSlideId?: number;
  id: number | string;
  type: string;
}

const ButtonSnippet = ({
  ariaLabel,
  autoHide,
  backgroundColor,
  buttonMaxWidth,
  buttonTextEn,
  buttonTextEs,
  className = 'fr-deletable',
  displayAsLink,
  destinationSlideId,
  id,
  type,
  ...props
}: ButtonSnippetProps) => (
  <span
    aria-label={ariaLabel}
    className={className}
    contentEditable={false}
    data-auto-hide={autoHide}
    data-background-color={backgroundColor}
    data-button-text-en={buttonTextEn}
    data-button-text-es={buttonTextEs}
    data-display-as-link={displayAsLink}
    data-html-element-id={id}
    data-html-element-type={type}
    data-max-width={buttonMaxWidth}
    data-updated-at={Date.now()}
    {...(destinationSlideId && { 'data-destination-slide-id': destinationSlideId })}
    {...props}
  />
);

export default ButtonSnippet;
